module.exports = __webpack_public_path__ + "static/landingVideo-0aafa1cb95e50f88b909efd1ed6fa112.mp4";